import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "nav-header" }
const _hoisted_2 = ["src"]

import { ref } from 'vue';
import menuOpen from '@/assets/menu-open.png';
import menuClose from '@/assets/menu-close.png';
import { NavLink } from "@/types/system/NavLink"
// 控制导航栏的展开和关闭

export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const isNavOpen = ref<boolean>(false);

// 切换导航栏状态
const toggleNav = () => {
  isNavOpen.value = !isNavOpen.value;
};

const navLinks: NavLink[] = [
  { to: '/', text: '首页' },
  { to: '/course', text: '课程' },
  { to: '/testhome', text: '测试' },
  { to: '/personal-center', text: '个人中心' },
  // {to:'/admin-home',text:'后台管理'}
];



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo-container" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Logo",
          class: "logo"
        }),
        _createElementVNode("span", { class: "company-name" }, "好端端教育")
      ], -1)),
      _createElementVNode("button", {
        class: "toggle-button",
        onClick: toggleNav
      }, [
        _createElementVNode("img", {
          src: isNavOpen.value ? _unref(menuOpen) : _unref(menuClose),
          alt: "Toggle Menu",
          class: "toggle-icon"
        }, null, 8, _hoisted_2)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["nav-links", { open: isNavOpen.value }])
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link) => {
        return _createElementVNode("div", {
          key: link.to
        }, [
          _createVNode(_component_router_link, {
            to: link.to
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.text), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ])
      }), 64))
    ], 2)
  ]))
}
}

})